export const questions_FR = [
    {
        question: "L’activité économique se réalise par des actes:",
        options: [
            "De production",
            "D'échange",
            "D'épargne",
            "Aucune réponse"
        ],
        answers: ["De production", "D'échange", "D'épargne"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les besoins économiques sont:",
        options: [
            "Rares",
            "Limités",
            "Evolutifs",
            "Aucune réponse"
        ],
        answers: ["Evolutifs"],
        chapter: "ch1",
        topic: "Besoins et biens économiques"
    },
    {
        question: "Un seul bien de production:",
        options: [
            "Satisfait directement toutes les demandes",
            "Peut satisfaire un certain type de besoin",
            "Peut-être immatériel ou matériel",
            "Aucune réponse"
        ],
        answers: ["Peut-être immatériel ou matériel", "Peut satisfaire un certain type de besoin"],
        chapter: "ch1",
        topic: "Besoin et bien économique"
    },
    {
        question: "La monnaie est un instrument:",
        options: [
            "D'échange",
            "De commune mesure entre les biens économiques",
            "D'épargne",
            "Aucune réponse"
        ],
        answers: ["D'échange", "De commune mesure entre les biens économiques", "D'épargne"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "Dans le choix du statut juridique d'une entreprise, font partie des critères à retenir:",
        options: [
            "L’imposition (Fiscalité)",
            "La règlementation",
            "La responsabilité face aux dettes",
            "Aucune réponse"
        ],
        answers: ["L’imposition (Fiscalité)", "La règlementation", "La responsabilité face aux dettes"],
        chapter: "ch1",
        topic: "Critères de choix du statut juridique"
    },
    {
        question: "Le salaire correspond:",
        options: [
            "A l'autofinancement",
            "Au revenu de l’entreprise",
            "Aux dividendes",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "La décision stratégique est:",
        options: [
            "Réversible",
            "A moyen terme",
            "Non programmable",
            "Aucune réponse"
        ],
        answers: ["Non programmable"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Ensemble de tous les éléments qui interviennent dans le processus de pilotage de l’entreprise, correspond au sous-système:",
        options: [
            "De decision",
            "D'information",
            "De production",
            "Opérationnel"
        ],
        answers: ["D'information"],
        chapter: "ch2",
        topic: "Sous-systèmes de l'entreprise"
    },
    {
        question: "La valeur ajoutée est la création de richesse:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "Les administrations publiques sont des organisations à buts lucratifs:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Agents économiques"
    },
    {
        question: "Le PIB est la production des agents économiques à l’intérieur et à l'extérieur du territoire national:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "La rente est le fruit du travail:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "Le Modèle des 5 forces de MINTZBERG est l’un des modèles le plus utilisé pour illustrer le micro environnement:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Structure organisationnelle de l'environnement"
    },
    {
        question: "Dans une SARL le nombre d’associés minimal est de 1:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Types d'entreprises"
    },
    {
        question: "D’un point de vue juridique, l’entreprise est une personne morale qui a les droits et obligations d’une personne physique:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Critères de choix du statut juridique"
    },
    {
        question: "Les actions sont les titres de propriété à long terme exprimant la fraction du capital social d’une entreprise:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Font partie des activités économiques:",
        options: [
            "La production",
            "L’échange de biens et services",
            "La consommation",
            "Aucune réponse"
        ],
        answers: ["La production", "L’échange de biens et services", "La consommation"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les salariés perçoivent:",
        options: [
            "Des dividendes",
            "Un revenu pour leur travail",
            "Un salaire",
            "Aucune réponse"
        ],
        answers: ["Un revenu pour leur travail", "Un salaire"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "Son rôle principal consiste à tenter d’avoir un avantage concurrentiel déterminant, celui qui modifie durablement les rapports de force, correspond au rôle de la:",
        options: [
            "Répartition de la richesse",
            "Stratégie",
            "Production",
            "Aucune réponse"
        ],
        answers: ["Stratégie"],
        chapter: "ch2",
        topic: "Structure organisationnelle"
    },
    {
        question: "Le SMIG est le salaire:",
        options: [
            "Nominal",
            "Réel",
            "Aucune réponse",
            "Minimum Garanti"
        ],
        answers: ["Minimum Garanti"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "La sensation de « manque » éprouvée par une personne et qui ne disparaît que par l’obtention d’un bien ou d’un service correspond:",
        options: [
            "A la satisfaction",
            "Au pouvoir d’achat",
            "A la consommation",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch1",
        topic: "Besoins et biens économiques"
    },
    {
        question: "Les décisions opérationnelles sont caractérisées par:",
        options: [
            "Horizons de temps: court terme",
            "Réversibilité de la décision: nulle",
            "Aucune réponse",
            "Actions correctives: faciles"
        ],
        answers: ["Horizons de temps: court terme", "Actions correctives: faciles"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Parmi les critères à prendre en considération dans le choix du statut juridique:",
        options: [
            "Le secteur d’activité",
            "Le nombre des associés",
            "Les incidences fiscales et le taux d’imposition",
            "La responsabilité légale face aux dettes de l’entreprise"
        ],
        answers: ["Le nombre des associés", "Les incidences fiscales et le taux d’imposition", "La responsabilité légale face aux dettes de l’entreprise"],
        chapter: "ch1",
        topic: "Critères de choix du statut juridique"
    },
    {
        question: "N'est pas un ensemble des moyens et procédures mis en place, afin de fournir aux membres de l’entreprise une représentation de la situation et du fonctionnement de celle-ci face à son environnement:",
        options: [
            "Sous-système de décision",
            "Sous-système d’information",
            "Sous-système de opérationnel",
            "Sous-système de production"
        ],
        answers: ["Sous-système de opérationnel", "Sous-système de production", "Sous-système de décision"],
        chapter: "ch2",
        topic: "Sous-systèmes de l'entreprise"
    },
    {
        question: "D’un point de vue économique l’entreprise est une personne morale qui n’a ni droits ni obligations:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Classification des entreprises"
    },
    {
        question: "Dans une SARL le nombre d’associés minimal est de 1 et maximal de 50:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Types d'entreprises"
    },
    {
        question: "L’entreprise est un système organisé du fait qu'elle est dotée d’une structure de fonctionnement permettant d’assurer la coordination des éléments du système:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "L’état fourni des services et biens marchands:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Agents économiques"
    },
    {
        question: "La monnaie n'est pas un instrument de paiement:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "La rente est un revenu périodique non obtenu par le travail:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "Le PIB est la production des agents économiques nationaux à l’intérieur et à l’extérieure du territoire national:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "Le pouvoir d’achat est la quantité de biens et de services que permet d'obtenir une certaine somme d'argent:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "Font partie des parties prenantes du Shareholder’s Model:",
        options: [
            "Les salariés",
            "Les pouvoirs publics",
            "Les sous-traitants",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch2",
        topic: "Parties prenantes de l'entreprise"
    },
    {
        question: "Les besoins de réalisation de soi et d'affirmation de son individualité sont les besoins:",
        options: [
            "Sociaux",
            "De sécurité",
            "Aucune réponse",
            "D’estime"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch1",
        topic: "Besoins et biens économiques"
    },
    {
        question: "Le système entreprise est un système:",
        options: [
            "Dynamique",
            "Organisé",
            "Régulé",
            "Statique"
        ],
        answers: ["Dynamique", "Organisé", "Régulé"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "Font partie des forces de Michael PORTER:",
        options: [
            "Menaces des nouveaux concurrents",
            "Rivalité entre les concurrents",
            "Politique économique",
            "Aucune réponse"
        ],
        answers: ["Menaces des nouveaux concurrents", "Rivalité entre les concurrents"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Parmi les déterminants influençant la demande:",
        options: [
            "Revenu des consommateurs",
            "Prix des produits de substitution",
            "Aucune réponse",
            "Prévisions des consommateurs"
        ],
        answers: ["Revenu des consommateurs", "Prix des produits de substitution", "Prévisions des consommateurs"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Font partie des paramètres psychologiques intervenant sur le comportement d’achat qui considèrent:",
        options: [
            "L'apprentissage",
            "Les motivations",
            "La classe sociale",
            "Aucune réponse"
        ],
        answers: ["L'apprentissage", "Les motivations"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Le degré d’inégalité accepté par les individus face au pouvoir et à l’autorité, correspond à:",
        options: [
            "La distance hiérarchique",
            "L'individualisme",
            "Le contrôle de l’incertitude",
            "Aucune réponse"
        ],
        answers: ["La distance hiérarchique"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "Les dividendes sont la part des bénéfices d'une société qui, sur décision de l‘assemblée générale (AG), est distribuée à chaque titulaire d'une part ou action:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Le but du Marketing, selon Henry MINTZBERG, est de rendre la vente superflue:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Dans les Décisions Opérationnelles, les actions correctives sont impossibles:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Dans la Structure Fonctionnelle, la répartition des tâches se fait par rapport aux régions. aux produits ou aux familles de produits et aux marchés:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Types de structures organisationnelles"
    },
    {
        question: "Le SNC est le statut adapté aux personnes seules qui souhaitent créer une société:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Types d'entreprises"
    },
    {
        question: "Les Valeurs sont les préférences collectives qui s’imposent au groupe, les croyances essentielles et les normes qui définissent les façons d’agir et de penser, etc..",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Micro-environnement"
    },
    {
        question: "Dans le Cycle de Vie d’un Produit, la phase de Maturité est caractérisée par un ralentissement du rythme des ventes:",
        options: [
            "Vrai",
            "Faux",
        ],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Une stock-option est un droit:",
        options: [
            "Attribué à quelques salariés",
            "Attribué à tous les salariés",
            "Aucune réponse",
        ],
        answers: ["Attribué à quelques salariés"],
        chapter: "ch2",
        topic: "Définition de l’entreprise"
    },
    {
        question: "Quels sont les trois types de décisions en entreprise?",
        options: [
            "Stratégique",
            "Tactique",
            "Opérationnelle",
            "Administrative"
        ],
        answers: ["Stratégique", "Tactique", "Opérationnelle"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Les décisions stratégiques sont caractérisées par:",
        options: [
            "Une portée à long terme",
            "Une focalisation sur les détails",
            "Une adaptation rapide aux changements",
            "Un impact limité sur l’entreprise"
        ],
        answers: ["Une portée à long terme"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "La structure d'une entreprise peut inclure:",
        options: [
            "Un centre opérationnel",
            "Un sommet stratégique",
            "Une technostructure",
            "Un support marketing"
        ],
        answers: ["Un centre opérationnel", "Un sommet stratégique", "Une technostructure"],
        chapter: "ch2",
        topic: "Structure organisationnelle"
    },
    {
        question: "Le modèle PESTEL analyse l'environnement sous des aspects:",
        options: [
            "Politiques et Économiques",
            "Financiers et Légaux",
            "Technologiques et Sociétaux",
            "Géographiques et culturels"
        ],
        answers: ["Politiques et Économiques", "Technologiques et Sociétaux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Les parties prenantes internes d'une entreprise incluent:",
        options: [
            "Les actionnaires",
            "Les clients",
            "La direction",
            "Les fournisseurs"
        ],
        answers: ["Les actionnaires", "La direction"],
        chapter: "ch2",
        topic: "Parties prenantes de l'entreprise"
    },
    {
        question: "La structure fonctionnelle se caractérise par:",
        options: [
            "Une spécialisation par compétences",
            "Une organisation par produit",
            "Une gestion flexible",
            "Une autonomie régionale"
        ],
        answers: ["Une spécialisation par compétences"],
        chapter: "ch2",
        topic: "Types de structures organisationnelles"
    },
    {
        question: "Dans une structure matricielle, chaque employé a:",
        options: [
            "Deux supérieurs hiérarchiques",
            "Un chef de département",
            "Un chef de projet et un responsable permanent",
            "Une gestion indépendante"
        ],
        answers: ["Deux supérieurs hiérarchiques", "Un chef de projet et un responsable permanent"],
        chapter: "ch2",
        topic: "Types de structures organisationnelles"
    },
    {
        question: "Une des fonctions principales de l'entreprise est:",
        options: [
            "La production",
            "La distribution",
            "La planification",
            "La finance"
        ],
        answers: ["La production"],
        chapter: "ch2",
        topic: "Définition de l’entreprise"
    },
    {
        question: "Dans un marché monopolistique le prix est fixé par:",
        options: [
            "Le gouvernement",
            "Les consommateurs",
            "Le marché international",
            "Le vendeur"
        ],
        answers: ["Le vendeur"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "L'or est un:",
        options: [
            "Instrument d'épargne (richesse)",
            "Instrument de règlement (paiement)",
            "Moyen de transport de la richesse",
            "Moyen de mesure de la valeur des biens et services"
        ],
        answers: ["Instrument de règlement (paiement)", "Instrument d'épargne (richesse)", "Moyen de mesure de la valeur des biens et services"],
        chapter: "ch1",
        topic: "Monnaie et utilité économique"
    },
    {
        question: "Ne font pas partie des activités économiques:",
        options: [
            "La production",
            "La consommation",
            "La réglementation",
            "Aucune réponse"
        ],
        answers: ["La réglementation"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Dans un marché de concurrence la quantité est fixée par:",
        options: [
            "Le gouvernement",
            "Les importations",
            "Les producteurs",
            "Le Marché"
        ],
        answers: ["Le Marché"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Le Monopole contrarié correspond à la situation où il y'a:",
        options: [
            "Une forte régulation",
            "Une forte demande",
            "Un nombre élevé de concurrents",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Dans une situation de monopole, l'optimum économique est atteint lorsque:",
        options: [
            "La production est au minimum",
            "Coût marginal = recette marginale",
            "La production est au maximum",
            "Le profit est maximum"
        ],
        answers: ["Le profit est maximum", "Coût marginal = recette marginale"],
        chapter: "ch1",
        topic: "Rendement et productivité"
    },
    {
        question: "La production des biens et services effectuée par tous les agents économiques (nationaux ou pas) sur un territoire donné pour une période déterminée est:",
        options: [
            "Le PNB",
            "Le PIB",
            "Le revenu national",
            "Le bénéfice"
        ],
        answers: ["Le PIB"],
        chapter: "ch2",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "Dans un marché concurrentiel le prix est fixé par:",
        options: [
            "Les consommateurs",
            "Les entreprises",
            "Le gouvernement",
            "Le Marché"
        ],
        answers: ["Le Marché"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "Font partie de l'environnement l'entreprise:",
        options: [
            "Les actionnaires",
            "Les clients",
            "Les fournisseurs",
            "Les employés"
        ],
        answers: ["Les fournisseurs", "Les clients"],
        chapter: "ch1",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Les décisions opérationnelles sont caractérisées par:",
        options: [
            "Une vision stratégique",
            "Des coûts élevés",
            "Aucune réponse",
            "Des implications à long terme"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Parmi les critères à prendre en considération dans le choix du statut juridique:",
        options: [
            "Les incidences fiscales et le taux d’imposition",
            "La responsabilité légale face aux dettes de l’entreprise",
            "Le niveau de concurrence",
            "Le nombre de personnes"
        ],
        answers: ["La responsabilité légale face aux dettes de l’entreprise", "Le nombre de personnes", "Les incidences fiscales et le taux d’imposition"],
        chapter: "ch1",
        topic: "Critères de choix du statut juridique"
    },
    {
        question: "L'entreprise est un système qui présente les caractéristiques suivantes:",
        options: [
            "Finalisé",
            "Désorganisé",
            "Aléatoire",
            "Concret"
        ],
        answers: ["Concret", "Finalisé"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "L'ensemble des forces/faiblesses qui agissent sur l'entreprise et qui contribuent en retour à générer un Feed-Back correspond à:",
        options: [
            "Les concurrents",
            "Le marché",
            "Aucune réponse",
            "L'environnement"
        ],
        answers: ["L'environnement"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Ceux qui effectuent le travail de base comme la production ou la commercialisation sont:",
        options: [
            "Les conseillers",
            "Aucune réponse",
            "Les investisseurs",
            "Les managers"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Découpage horizontal du travail réalisé par rapport aux grandes fonctions est la:",
        options: [
            "Structure fonctionnelle",
            "Structure hiérarchique",
            "Structure d'équipe",
            "Structure matricielle"
        ],
        answers: ["Structure fonctionnelle"],
        chapter: "ch2",
        topic: "Types de structures organisationnelles"
    },
    {
        question: "Ceux qui détiennent le capital social de l'entreprise dont le rôle premier est d'apporter les fonds nécessaires au développement de l'entreprise sont:",
        options: [
            "Les clients",
            "Les employés",
            "Les experts",
            "Les actionnaires"
        ],
        answers: ["Les actionnaires"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Font partie des 5 forces de PORTER:",
        options: [
            "Pouvoir des employés",
            "Pouvoir des actionnaires",
            "Pouvoir des concurrents",
            "Pouvoir des négociations des fournisseurs"
        ],
        answers: ["Pouvoir des négociations des fournisseurs"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "L’économie a pour objectif d’expliquer les phénomènes économiques et d’indiquer les décisions économiques optimales:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Uniquement les ménages constituent des centres de décisions économiques:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Agents économiques"
    },
    {
        question: "Les coûts fixes varient en fonction de la quantité produite:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Théorie des coûts"
    },
    {
        question: "Une entreprise publique est une entreprise qui appartient en totalité à l'Etat ou à des collectivités locales:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Agents économiques"
    },
    {
        question: "L’impôt est la part des bénéfices d'une société qui, sur décision de l‘Assemblée Générale, est distribuée à chaque titulaire d'une part ou action:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Le modèle souvent utilisé pour illustrer le macro-environnement est le modèle des 5 Forces de PORTER:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "L’EURL est une entreprise à responsabilité illimitée:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Types d'entreprises"
    },
    {
        question: "L’iso-coût pour le producteur n'est pas une contrainte pour le producteur:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Théorie des coûts"
    },
    {
        question: "L’entreprise est une entité économique dynamique:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Définition de l’entreprise"
    },
    {
        question: "L’entrepreneuriat est, au sens économique, l’action de créer de la richesse et/ou de l'emploi par la création ou la reprise d'une entreprise:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définition de l’entreprise"
    },
    {
        question: "Les décisions stratégiques engagent l’entreprise sur une période moyenne:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Les besoins économiques ne sont souvent pas évolutifs:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Besoins et biens économiques"
    },
    {
        question: "La productivité marginale est l’unité supplémentaire de L ou de K, qui permet d’obtenir une quantité supplémentaire de produit:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Rendement et productivité"
    },
    {
        question: "La Macroéconomie analyse les phénomènes économiques d’une manière globale:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les coûts variables sont proportionnels à l’activité (production):",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Théorie des coûts"
    },
    {
        question: "Les ressources économiques sont limitées:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les entreprises sont un agent économique, qui produit des biens et services à but lucratif:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définition de l’entreprise"
    },
    {
        question: "Le salaire exprimé en monnaie et versé au salarié correspond au salaire:",
        options: [
            "Réel",
            "Nominal",
            "Minimum",
            "Maximum"
        ],
        answers: ["Nominal"],
        chapter: "ch2",
        topic: "Indicateurs économiques (PIB, PNB, salaire...)"
    },
    {
        question: "Le Monopole bilatéral correspond à la situation où il y’a:",
        options: [
            "Un seul offreur, un seul demandeur",
            "Un seul offreur, plusieurs demandeurs",
            "Plusieurs offreurs, un seul demandeur",
            "Aucune réponse"
        ],
        answers: ["Un seul offreur, un seul demandeur"],
        chapter: "ch1",
        topic: "Marché et demande"
    },
    {
        question: "L’économie est une science sociale qui s’intéresse au comportement des agents économiques:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les agents économiques que ce soient des individus ou des organismes constituent des centres de décisions économiques:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Agents économiques"
    },
    {
        question: "L’iso-coût pour le producteur est une contrainte:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch1",
        topic: "Théorie des coûts"
    },
    {
        question: "L'état produit des biens et services à but lucratif:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Agents économiques"
    },
    {
        question: "La Microéconomie analyse les phénomènes économiques d’une manière globale:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "La productivité moyenne est l’unité supplémentaire de L ou de K, qui permet d’obtenir une quantité supplémentaire de produit:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Rendement et productivité"
    },
    {
        question: "Les besoins économiques portent sur des biens abondants dans la nature:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch1",
        topic: "Besoins et biens économiques"
    },
    {
        question: "Les entreprises doivent tenir compte des normes écologiques imposées:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Le mode de production désigne la façon dont les différents facteurs de production sont organisés pour réaliser un produit ou un service:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Modes de production"
    },
    {
        question: "La production hybride se fait par trois sous-systèmes : discontinue en amont de la chaîne de production, automatique dans la chaîne de production et discontinue en aval de la chaîne de production:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Modes de production"
    },
    {
        question: "Les acteurs internes et externes de l’entreprise sont des agents qui agissent tous en synergie pour un même objectif:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Parties prenantes de l'entreprise"
    },
    {
        question: "Le système de production décrit l’ensemble du processus grâce auquel l’entreprise produit un bien ou un service apte à satisfaire une demande à l’aide de facteurs de production acquis sur le marché:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "L'entreprise, à partir du moment où elle emploie du personnel, se voit investie d'une fonction sociale:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Définition de l’entreprise"
    },
    {
        question: "La veille est un outil de surveillance de l’environnement:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Le sous-système d’information est l’ensemble des moyens et procédures mis en place, afin de fournir aux membres de l’entreprise une représentation de la situation et du fonctionnement de celle-ci face à son environnement:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch2",
        topic: "Sous-systèmes de l’entreprise"
    },
    {
        question: "Le Modèle des 5 forces de Michael PORTER est l’un des modèles le plus utilisé pour illustrer le macro-environnement:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "L’entreprise est un système concret du fait qu'elle est dotée d’une structure de fonctionnement permettant d’assurer la coordination des éléments du système:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "L’analyse SWOT permet de déterminer uniquement les forces et les faiblesses:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "L’entreprise est une entité économique fermée:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Système entreprise"
    },
    {
        question: "Dans un système automatique de production, la production est assurée sans intervention humaine:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "La stratégie est une procédure formalisée de prise de décision, par laquelle l'entreprise élabore une représentation voulue de son état futur et les modalités de mise en œuvre correspondantes:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Le Micro environnement n’est pas propre à une entreprise, mais à un ensemble d’entreprises:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "La Fonction production doit satisfaire:",
        options: [
            "La qualité des produits",
            "Les Délais de production",
            "Les coûts de production",
            "Les coûts du personnel",
            "Aucune réponse"
        ],
        answers: ["La qualité des produits", "Les Délais de production", "Les coûts de production"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Production en petites séries diversifiées de produits identiques est la production:",
        options: [
            "Par lots",
            "En continu",
            "En série",
            "Aucune réponse"
        ],
        answers: ["Par lots"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "La détermination de l’ordre de passage concerne la planification de l’utilisation des ressources disponibles en homme et en machine est:",
        options: [
            "L’ordonnancement",
            "La planification",
            "La gestion",
            "Aucune réponse"
        ],
        answers: ["L’ordonnancement"],
        chapter: "ch3",
        topic: "Ordonnancement"
    },
    {
        question: "Prestation en travail, sans transformation de matière, immatérielle et non stockable, correspond à la production:",
        options: [
            "De la marchandise",
            "Des produits",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Le système de production cherche à:",
        options: [
            "Produire la quantité demandée",
            "Produire en temps voulu",
            "Optimiser les ressources de production",
            "Produire en quantité minimale",
        ],
        answers: ["Produire la quantité demandée", "Produire en temps voulu", "Optimiser les ressources de production"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Lorsque c’est la demande en aval qui entraîne la production c’est une production à",
        options: [
            "Flux tirés",
            "Flux poussés",
            "Flux",
            "Aucune réponse"
        ],
        answers: ["Flux tirés"],
        chapter: "ch3",
        topic: "Flux de production"
    },
    {
        question: "L’activité socialement organisée destinée à créer des biens et des services à partir de facteurs de production acquis sur le marché est:",
        options: [
            "La production",
            "La distribution",
            "La consommation",
            "Aucune réponse"
        ],
        answers: ["La production"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Méthode de planification des besoins en composants basée sur la nomenclature des produits est:",
        options: [
            "La MRP",
            "La ERP",
            "Le PDP",
            "Aucune réponse"
        ],
        answers: ["La MRP"],
        chapter: "ch3",
        topic: "Outils de gestion de production"
    },
    {
        question: "Font partie des modes de production:",
        options: [
            "La production continue",
            "La production discontinue",
            "La production hybride",
            "Aucune réponse"
        ],
        answers: ["La production continue", "La production discontinue", "La production hybride"],
        chapter: "ch3",
        topic: "Modes de production"
    },
    {
        question: "Le système qui décrit l’ensemble du processus grâce auquel l’entreprise produit un bien ou un service est le système de:",
        options: [
            "Aucune réponse",
            "Production",
            "Distribution",
            "Marketing"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "La finance qui s’intéresse au budget de l’état et au financement des collectivités locales et des organismes sociaux est la finance:",
        options: [
            "Privée",
            "Commerciale",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch4",
        topic: "Planification financière"
    },
    {
        question: "Font partir des buts de la fonction finance:",
        options: [
            "Fournir et de garantir aux dirigeants des informations, tant financières que non financières, actuelles, pertinentes et fiables pour une meilleure prise de décision",
            "Contribuer à la gestion des risques de l’entreprise",
            "D’aider l’entreprise à utiliser les ressources de façon économique, efficiente et efficace",
            "Aucune réponse"
        ],
        answers: ["Fournir et de garantir aux dirigeants des informations, tant financières que non financières, actuelles, pertinentes et fiables pour une meilleure prise de décision", "Contribuer à la gestion des risques de l’entreprise", "D’aider l’entreprise à utiliser les ressources de façon économique, efficiente et efficace"],
        chapter: "ch4",
        topic: "Fonction finance"
    },
    {
        question: "Afin de faire face aux engagements de paiement à court, l'entreprise doit avoir une bonne:",
        options: [
            "Fiscalité",
            "Rentabilité",
            "Liquidité",
            "Structure"
        ],
        answers: ["Liquidité"],
        chapter: "ch4",
        topic: "Planification financière"
    },
    {
        question: "Font partie des facteurs qui déterminent le coût ou le montant de l’intérêt:",
        options: [
            "La somme prêtée",
            "La durée du prêt",
            "La loi",
            "Aucune réponse"
        ],
        answers: ["La somme prêtée", "La durée du prêt"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "La Réduction exceptionnelle souvent accordée pour réparer une erreur du fournisseur est:",
        options: [
            "Rabais",
            "Remise",
            "Ristourne",
            "Aucune réponse"
        ],
        answers: ["Rabais"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "Parmi les informations qu’on trouve sur une facture:",
        options: [
            "Eléments d'identification du vendeur",
            "Rappel des conditions de vente",
            "Conditions et délais",
            "Date de paiement"
        ],
        answers: ["Eléments d'identification du vendeur", "Rappel des conditions de vente", "Date de paiement", "Conditions et délais"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "Les investissements dans les brevets et licences sont des investissements:",
        options: [
            "Immobilisés",
            "Matériels",
            "Financiers",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch4",
        topic: "Types d’investissement"
    },
    {
        question: "Font partie des sources des financements internes:",
        options: [
            "L'autofinancement",
            "Les cessions d'actif immobilisé",
            "Les emprunts",
            "Aucune réponse"
        ],
        answers: ["L'autofinancement", "Les cessions d'actif immobilisé"],
        chapter: "ch4",
        topic: "Sources de financement"
    },
    {
        question: "Les Business Angels sont des acteurs importants dans le financement par:",
        options: [
            "Capital-risque",
            "Crédit",
            "Emprunt",
            "Aucune réponse"
        ],
        answers: ["Capital-risque"],
        chapter: "ch4",
        topic: "Sources de financement"
    },
    {
        question: "Système par lequel une entreprise cède des immobilisations à une société de crédit-bail pour lui relouer ensuite est:",
        options: [
            "Les cessions bail",
            "Un financement interne",
            "Un financement externe",
            "Aucune réponse"
        ],
        answers: ["Les cessions bail", "Un financement interne"],
        chapter: "ch4",
        topic: "Sources de financement"
    },
    {
        question: "Le déclenchement de l’étape suivante dans la production à flux poussés se fait par la disponibilité du produit en amont:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Flux de production"
    },
    {
        question: "L’approvisionnement est l’activité socialement organisée, destinée à créer des biens et des services à partir de facteurs de production acquis sur le marché:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "La Fonction production est uniquement l’activité de transformation des flux de matières premières et d’informations en produits finis grâce aux hommes et aux machines:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "L’ordonnancement permet d’assurer la continuité des opérations et de produire les quantités désirées tout en minimisant les délais et en utilisant au mieux les moyens de production:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Ordonnancement"
    },
    {
        question: "La loi de Pareto est la loi des 20/80:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "Un crédit est une mise à disposition d'argent sous forme de prêt, consentie par un créancier (prêteur) à un débiteur (emprunteur):",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "L’intérêt peut être défini comme la rémunération d’un prêt d’argent:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "L’actualisation est une technique qui consiste à faire reculer dans le temps une valeur future pour calculer sa valeur présente:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "L’investissement de modernisation ou de productivité concerne le remplacement d’un équipement par un autre plus performant:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Types d’investissement"
    },
    {
        question: "Le service est une prestation en travail avec transformation de matière. Il est immatériel et non stockable:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Dans l’intérêt simple, l’intérêt génère de l’intérêt:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "Les annuités sont une suite de flux monétaires perçues ou réglées mensuellement:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Dans l’amortissement dégressif, la base d’amortissement est constante:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Les mathématiques financières sont une branche de la physique quantique:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Les opérations de financement concernent l’acquisition ou la cession d’immobilisations:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Planification financière"
    },
    {
        question: "L’investissement désigne les méthodes et les institutions qui permettent d'obtenir les capitaux nécessaires, dont on ne dispose pas et de placer ceux dont on a la disposition sans emploi immédiat ou que l'on compte utiliser plus tard:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Types d’investissement"
    },
    {
        question: "Les informations dans le cadre de la décision stratégique sont:",
        options: [
            "Précises",
            "Incertaines et exogènes",
            "Certaines et endogènes",
            "Aucune réponse"
        ],
        answers: ["Incertaines et exogènes"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "L’analyse SWOT se fait sur un plan:",
        options: [
            "Interne",
            "Externe",
            "Interne et externe",
            "Aucune réponse"
        ],
        answers: ["Interne et externe"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "Le modèle PESTEL sert à:",
        options: [
            "Déterminer l’influence de l’environnement sur l’entreprise",
            "Déterminer l’influence de l’entreprise sur l’environnement", 
            "Déterminer l’influence de l’entreprise sur l’environnement et de l’environnement sur l’entreprise",
            "Aucune réponse"
        ],
        answers: ["Déterminer l’influence de l’environnement sur l’entreprise"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "La mesure de l’amortissement donne:",
        options: [
            "La valeur actuelle des équipements",
            "La dépréciation des équipements",
            "Aucune réponse",
        ],
        answers: ["La dépréciation des équipements"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Le système de veille assure, en priorité, à l’entreprise:",
        options: [
            "De connaitre ses opportunités/menaces",
            "De connaitre ses forces/faiblesses",
            "De connaitre l'efficacité de ses employés",
            "Aucune réponse"
        ],
        answers: ["De connaitre ses opportunités/menaces"],
        chapter: "ch2",
        topic: "Environnement de l’entreprise"
    },
    {
        question: "L'entreprise est:",
        options: [
            "Une organisation sociale",
            "Un centre de décision",
            "Un centre d’échange",
            "Une entité abstraite"
        ],
        answers: ["Une organisation sociale", "Un centre de décision", "Un centre d’échange"],
        chapter: "ch2",
        topic: "Définition de l’entreprise"
    },
    {
        question: "Décisions s’appliquant dans le cadre de la gestion courante de l’entreprise et concerne l’utilisation optimale des ressources allouées dans le cadre du processus productif de l’entreprise sontles décisions:",
        options: [
            "Stratégiques",
            "Opérationnelles",
            "Tactiques",
            "Aucune réponse"
        ],
        answers: ["Opérationnelles"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Les détenteurs du capital social (actionnaires) perçoivent:",
        options: [
            "Les dividendes",
            "Les salaires",
            "Les intérêts",
            "Aucune réponse"
        ],
        answers: ["Les dividendes"],
        chapter: "ch1",
        topic: "Définitions de l’économie"
    },
    {
        question: "Les décisions opérationnelles sont:",
        options: [
            "Réversibles",
            "Irréversibles",
            "On ne peut rien dire",
            "Aucune réponse",
        ],
        answers: ["Réversibles"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "Les actions correctives dans l’entreprise peuvent être facilement prises au niveau des décisions:",
        options: [
            "Stratégiques",
            "Opérationnelles",
            "Tactiques",
            "Aucune réponse"
        ],
        answers: ["Opérationnelles"],
        chapter: "ch2",
        topic: "Types de décisions en entreprise"
    },
    {
        question: "La Fonction production consiste à transformer des matières premières en produits finis:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Dans un système de production en flux tendu, l’objectif principal est de minimiser les stocks:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Flux de production"
    },
    {
        question: "Les stocks de produits finis incluent les articles qui ont subi toutes les étapes de production:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "Dans une production en série, les produits sont fabriqués individuellement en fonction de la demande:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "La fonction financière englobe les activités:",
        options: [
            "D’aide à la décision",
            "De contrôle",
            "De Commercialisation",
            "Aucune réponse"
        ],
        answers: ["D’aide à la décision", "De contrôle"],
        chapter: "ch4",
        topic: "Fonction finance"
    },
    {
        question: "L’intérêt peut être défini comme la rémunération (compensation) d’un prêt d’argent:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "L’intérêt composé se calcule toujours sur le principal:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "Sont des méthodes d'évaluation de la rentabilité globale d'un investissement:",
        options: [
            "Le taux de rentabilité interne",
            "Le délai de récupération",
            "L'indice de profitabilité",
            "Total des coûts"
        ],
        answers: ["Le taux de rentabilité interne", "Le délai de récupération", "L'indice de profitabilité"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "L'investissement est définit comme la perte de valeur d'un bien (immobilisation) d'une entreprise en raison de l'usure provoquée par son utilisation:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Types d’investissement"
    },
    {
        question: "Appartient aux modes de calcul d’amortissement:",
        options: [
            "Linéaire",
            "Progressif",
            "Double",
            "Aucune réponse"
        ],
        answers: ["Linéaire", "Progressif"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Une facture est:",
        options: [
            "Un document comptable",
            "Une Attestation d'achat de bien/service seulement",
            "Une Attestation d'achat et de vente de bien/service",
            "Aucune réponse"
        ],
        answers: ["Une Attestation d'achat et de vente de bien/service", "Un document comptable"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "Le montant TTC est:",
        options: [
            "Le net financier + la TVA",
            "Le montant où toutes les taxes sont comprises",
            "Le montant HT",
            "Aucune réponse"
        ],
        answers: ["Le montant où toutes les taxes sont comprises", "Le net financier + la TVA"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "La TVA est une taxe sur la valeur acquise:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "Les annuités variables à la fin de période et les annuités variables au début de période sont calculées de la même manière:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Une somme de 15000DA est placée sur un compte du 23 Avril au 9 Août au taux simple de 5 % (annuel). Calculer le montant de l’intérêt produit à  l’échéance et la valeur acquise par ce capital:",
        options: [
            "15225DA",
            "15000DA",
            "15450DA",
            "Aucune réponse"
        ],
        answers: ["15225DA"],
        chapter: "ch4",
        topic: "Intérêt et crédit"
    },
    {
        question: "L’investissement entraîne une dépense qui permettra d’avoir des:",
        options: [
            "Recettes",
            "Charges",
            "Aucune réponse"
        ],
        answers: ["Recettes"],
        chapter: "ch4",
        topic: "Types d’investissement"
    },
    {
        question: "Pour l'indice de profitabilité (IP):",
        options: [
            "IP = Cash-Flow actualisés / Investissement",
            "si IP > 1 alors l’investissement est rentable",
            "si IP < 1 alors l’investissement est rentable",
            "Aucune réponse"
        ],
        answers: ["IP = Cash-Flow actualisés / Investissement", "si IP > 1 alors l’investissement est rentable"],
        chapter: "ch4",
        topic: "Mathématiques financières (amortissement, actualisation, annuités, rentabilité...)"
    },
    {
        question: "Le financement via le marché boursier est une méthode de financement externe:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Sources de financement"
    },
    {
        question: "La méthode ABC a le même principe de la loi Pareto, sauf que la méthode ABC fait intervenir 4 groupes:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "Sont des méthodes de valorisation des sorties du stock:",
        options: [
            "FIFO",
            "LIFO",
            "CMUP",
            "PRIO"
        ],
        answers: ["FIFO", "LIFO", "CMUP"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "La logistique est l’ensemble des activités qui ont pour but la mise à disposition au moindre coût d’une quantité de produits, à l’endroit et au moment où une demande existe:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Les ventes représentent l'ensemble des ressources (moyens) déployés pour tous les  actes d’approvisionnement et de fourniture de biens et de services nécessaires au bon fonctionnement d’une entreprise:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Des types de fabrication:",
        options: [
            "La fabrication pour stockage, la fabrication mixte, la fabrication à la commande",
            "La fabrication pour stockage, la fabrication pour commande, la fabrication mixte",
            "Aucune réponse"
        ],
        answers: ["La fabrication pour stockage, la fabrication mixte, la fabrication à la commande"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Les ristournes sont toujours appliquées avant les remises :",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Facturation"
    },
    {
        question: "Le Kaizen est un terme japonais signifiant fiche ou étiquette:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch4",
        topic: "Outils de gestion de production"
    },
    {
        question: "Depuis le début de 20ème siècle le facteur humain est considéré comme créateur de valeur ajoutée pour l’entreprise:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "La finance publique s’intéresse au financement et au budget de l’état:",
        options: ["Vrai", "Faux"],
        answers: ["Vrai"],
        chapter: "ch4",
        topic: "Sources de financement"
    },
    {
        question: "Font partie des objectifs de la fonction production:",
        options: [
            "L’optimisation des achats",
            "L’augmentation de la productivité",
            "La diminution des frais généraux",
            "Toutes les réponses"
        ],
        answers: ["Toutes les réponses"],
        chapter: "ch3",
        topic: "Fonction production"
    },
    {
        question: "Type de fabrication qui concerne les produits peu coûteux ou d’usage général qui sont fabriqués en grande quantité:",
        options: [
            "La fabrication pour stockage",
            "La fabrication à la commande",
            "La fabrication mixte",
            "Aucune réponse"
        ],
        answers: ["La fabrication pour stockage"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Dans une production de type «Flow-Shop», l’élaboration du produit entraîne une utilisation des postes de charge dans un ordre variable:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Dans la production unitaire, des produits standards sont fabriqués en très grande quantité, nécessitant l’utilisation d’un outil de production spécialisé:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Types de production"
    },
    {
        question: "Le pilotage de la production a pour objet d’assurer le pilotage des approvisionnements en articles achetés ou fabriqués:",
        options: ["Vrai", "Faux"],
        answers: ["Faux"],
        chapter: "ch3",
        topic: "Fontion production"
    },
    {
        question: "Font partie des objectifs de l’approvisionnement:",
        options: [
            "Assurer la sécurité et la régularité des approvisionnements",
            "Diminuer le poids des en-cours",
            "Améliorer le rapport Qualité/Prix des produits achetés",
            "Toutes les réponses"
        ],
        answers: ["Assurer la sécurité et la régularité des approvisionnements", "Améliorer le rapport Qualité/Prix des produits achetés"],
        chapter: "ch3",
        topic: "Gestion des stocks"
    },
    {
        question: "Le cycle qui comprend toutes les opérations relatives à la production et à la vente des produits ou services de l’entreprise est le:",
        options: [
            "Cycle de financement",
            "Cycle d’exploitation",
            "Cycle d’investissement",
            "Aucune réponse",
            "Toutes les réponses"
        ],
        answers: ["Cycle d’exploitation"],
        chapter: "ch4",
        topic: "Planification financière"
    },
    {
        question: "Font partie des outils de gestion de production:",
        options: [
            "Pareto",
            "ABC",
            "Toutes les réponses",
            "PDP",
            "Aucune réponse"
        ],
        answers: ["Aucune réponse"],
        chapter: "ch3",
        topic: "Outils de gestion de production"
    }
];

export function findRepeatedQuestions(questions) {
    const questionCount = {};
    const repeatedQuestions = [];

    questions.forEach((item) => {
        const questionText = item.question;
        questionCount[questionText] = (questionCount[questionText] || 0) + 1;
    });
    for (const question in questionCount) {
        if (questionCount[question] > 1) {
            repeatedQuestions.push(question);
        }
    }
    if (repeatedQuestions.length > 0) {
        console.log("Repeated questions:");
        repeatedQuestions.forEach((question) => console.log(question));
    } else {
        console.log("No repeated questions found.");
    }
}